import { MasterL10nMessages } from '@sm/question-ui/respondent-survey';
import { defineMessages } from '@sm/intl';

/**
 * Copy used by SMQuestions - re-declaring the messages here allows translation into the
 * 56 languages needed by RespWeb (as opposed to the 16 in SMQuestions)
 */
export const COPY: MasterL10nMessages = defineMessages({
  QUESTION_TITLE: {
    id: 'QuestionFieldLayoutTemplate.QUESTION_TITLE',
    defaultMessage: 'Question Title',
    description: '[Type: Label][Vis: low] - question landmark for screen readers only',
  },

  OK_LABEL: {
    id: 'Button.OK_LABEL',
    defaultMessage: 'OK',
    description: '[Type: button][Vis: high] - question ok label',
  },
});

export default COPY;
